var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "er2e3x9yna",
    d: "M17.778 16v-.889l-3.556-3.555-1.778 1.777L8 8.89l-4.444 4.444V16h14.222zm0 1.778H3.556c-.982 0-1.778-.797-1.778-1.778V5.333c0-.981.796-1.777 1.778-1.777h14.222c.981 0 1.778.796 1.778 1.777V16c0 .981-.797 1.778-1.778 1.778z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    transform: "translate(-309 -855) translate(105 119) translate(160 728) translate(44 8)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-309 -855) translate(105 119) translate(160 728) translate(44 8) translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.333 5.333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dsyxqvavjb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#er2e3x9yna"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#323232",
    xlinkHref: "#er2e3x9yna"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#dsyxqvavjb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.333V21.333H0z"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.9f2f477847dc49c2d7504905036743bf.svg";
export { ForwardRef as ReactComponent };